export const REDIRECT_TIMEOUT = {
  UNAUTHENTICATED: 1000,
} as const;
